import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["name", "form", "input", "run", "modal"]
  static values = {
    maxBytes: Number,
    tooLarge: String,
    readyCount: { type: Number, default: 0 }
  }

  connect() {
    this.confirmedRerun = false
    this.syncRunEnabled()
  }

  dragover(event) {
    event.preventDefault()
    this.element.classList.add("ring-2", "ring-orange")
  }

  dragleave(event) {
    event.preventDefault()
    this.element.classList.remove("ring-2", "ring-orange")
  }

  drop(event) {
    event.preventDefault()
    this.element.classList.remove("ring-2", "ring-orange")
    const file = event.dataTransfer.files[0]
    if (!file || !this.hasInputTarget) return

    const transfer = new DataTransfer()
    transfer.items.add(file)
    this.inputTarget.files = transfer.files
    this.stageFile(file)
  }

  changed(event) {
    this.stageFile(event.target.files[0])
  }

  productChanged() {
    this.syncRunEnabled()
  }

  stageFile(file) {
    if (!file) {
      this.syncRunEnabled()
      return
    }
    if (this.overMaxSize(file)) {
      this.showSizeError()
      this.syncRunEnabled()
      return
    }

    if (this.hasNameTarget) {
      this.nameTarget.classList.remove("text-vulnerable")
      this.nameTarget.classList.add("text-gray-200")
      this.nameTarget.textContent = file.name
    }
    this.syncRunEnabled()
  }

  guardSubmit(event) {
    if (!this.needsConfirm() || this.confirmedRerun) return

    event.preventDefault()
    this.openModal()
  }

  confirmRerun(event) {
    event.preventDefault()
    this.confirmedRerun = true
    this.closeModal()
    if (this.hasFormTarget) this.formTarget.requestSubmit()
  }

  cancelRerun(event) {
    event.preventDefault()
    this.closeModal()
  }

  needsConfirm() {
    return this.readyCountValue === 1 || this.readyCountValue === 2
  }

  syncRunEnabled() {
    if (!this.hasRunTarget) return

    const enabled = this.hasFile() && this.hasProduct()
    this.runTarget.disabled = !enabled
    this.runTarget.classList.toggle("opacity-50", !enabled)
  }

  hasFile() {
    return this.hasInputTarget && this.inputTarget.files?.length > 0
  }

  hasProduct() {
    return Boolean(this.element.querySelector("input[name='ai_risk_report[secure_access]']:checked"))
  }

  openModal() {
    if (!this.hasModalTarget) return
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.setAttribute("aria-hidden", "false")
  }

  closeModal() {
    if (!this.hasModalTarget) return
    this.modalTarget.classList.add("hidden")
    this.modalTarget.setAttribute("aria-hidden", "true")
  }

  overMaxSize(file) {
    return this.hasMaxBytesValue && file.size > this.maxBytesValue
  }

  showSizeError() {
    if (this.hasNameTarget) {
      this.nameTarget.classList.remove("text-gray-400")
      this.nameTarget.classList.add("text-vulnerable")
      this.nameTarget.textContent = this.tooLargeValue
    }
    if (this.hasInputTarget) this.inputTarget.value = ""
  }
}
